import { Injectable } from '@angular/core';
import type { DisplayedElements } from '../models';

@Injectable({
  providedIn: 'root',
})
export class RoomConsumptionsViewService {
  public getDefaultViewMode(): Readonly<DisplayedElements> {
    return {
      consumptionNormalizedTabs: false,
      renderedPie: false,
      renderedEmptyChart: false,
      timerangeSelector: false,
      consumptionTable: false,
      editRoomsButton: false,
      pieChart: false,
    } as const;
  }

  public getInvalidRangeViewMode(displayedElements: DisplayedElements): Readonly<DisplayedElements> {
    return {
      ...displayedElements,
      consumptionNormalizedTabs: true,
      timerangeSelector: true,
      renderedPie: true,
      renderedEmptyChart: true,
      consumptionTable: false,
      editRoomsButton: false,
      pieChart: false,
    } as const;
  }

  public getValidRangeViewMode(displayedElements: DisplayedElements): Readonly<DisplayedElements> {
    return {
      ...displayedElements,
      consumptionNormalizedTabs: true,
      timerangeSelector: true,
      renderedPie: true,
      renderedEmptyChart: false,
      consumptionTable: true,
      editRoomsButton: true,
      pieChart: true,
    } as const;
  }

  public getLoadErrorViewMode(displayedElements: DisplayedElements): Readonly<DisplayedElements> {
    return {
      ...displayedElements,
      consumptionNormalizedTabs: false,
      timerangeSelector: false,
      renderedPie: true,
      renderedEmptyChart: false,
      consumptionTable: false,
      editRoomsButton: false,
      pieChart: false,
    } as const;
  }

  public getNoRoomsAvailableViewMode(displayedElements: DisplayedElements): Readonly<DisplayedElements> {
    return {
      ...displayedElements,
      consumptionNormalizedTabs: false,
      timerangeSelector: false,
      renderedPie: false,
      renderedEmptyChart: true,
      consumptionTable: false,
      editRoomsButton: false,
      pieChart: true,
    } as const;
  }

  public getMissingRoomSurfaceViewMode(displayedElements: DisplayedElements): Readonly<DisplayedElements> {
    return {
      ...displayedElements,
      consumptionNormalizedTabs: true,
      timerangeSelector: false,
      renderedPie: true,
      renderedEmptyChart: false,
      consumptionTable: false,
      editRoomsButton: true,
      pieChart: false,
    } as const;
  }

  public getConsumptionDataAvailableViewMode(displayedElements: DisplayedElements): Readonly<DisplayedElements> {
    return {
      ...displayedElements,
      consumptionNormalizedTabs: true,
      timerangeSelector: true,
      renderedPie: true,
      renderedEmptyChart: false,
      consumptionTable: true,
      editRoomsButton: true,
      pieChart: true,
    } as const;
  }
}
